import { initContract as _e } from "@ts-rest/core";
import Ae, { z as n } from "zod";
const De = "3.0.2", qe = {
  "/dataset/{datasetId}/locations": {
    get: {
      description: "Obtains all the locations for a dataset by the dataset ID, which by passing in the appropriate options, might be in different formats",
      summary: "obtains a dataset's locations",
      tags: [],
      parameters: [
        {
          name: "datasetId",
          in: "path",
          required: !0,
          schema: {
            type: "string",
            pattern: "^[A-Za-z0-9_-]+$"
          },
          description: "uniquely specifies the dataset wanted"
        }
      ],
      operationId: "getDatasetLocations",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                type: "array",
                items: {
                  type: "array",
                  items: {
                    type: "number"
                  },
                  minItems: 2,
                  maxItems: 2,
                  nullable: !0
                },
                description: "the dataset matching the supplied ID"
              }
            }
          }
        },
        400: {
          description: "400",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        },
        404: {
          description: "404",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        }
      }
    }
  },
  "/dataset/{datasetId}/search": {
    get: {
      description: "Obtains an array of dataset item indexes, which match the search criteria supplied",
      summary: "obtains a list of dataset entries satisfying the search criteria supplied",
      tags: [],
      parameters: [
        {
          name: "datasetId",
          in: "path",
          required: !0,
          schema: {
            type: "string",
            pattern: "^[A-Za-z0-9_-]+$"
          },
          description: "uniquely specifies the dataset wanted"
        },
        {
          name: "text",
          in: "query",
          description: "a text fragment to match",
          schema: {
            type: "string"
          }
        },
        {
          name: "filter",
          in: "query",
          description: "uniquely specifies the taxonomy filter items wanted",
          schema: {
            oneOf: [
              {
                type: "array",
                items: {
                  type: "string"
                }
              },
              {
                type: "string"
              }
            ]
          }
        },
        {
          name: "returnProps",
          in: "query",
          description: "The props to return as an array of item objects. If not specified, only an flattened array of indexes is returned.",
          schema: {
            type: "array",
            items: {
              type: "string"
            }
          }
        },
        {
          name: "page",
          in: "query",
          description: "The page number to return. If not specified, all items are returned.",
          schema: {
            type: "integer",
            minimum: 0,
            nullable: !0
          }
        },
        {
          name: "pageSize",
          in: "query",
          description: "The number of items per page. If not specified, all items are returned.",
          schema: {
            type: "integer",
            minimum: 0,
            exclusiveMinimum: 0
          }
        }
      ],
      operationId: "searchDataset",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                oneOf: [
                  {
                    type: "array",
                    items: {
                      type: "integer",
                      minimum: 0
                    }
                  },
                  {
                    type: "array",
                    items: {
                      allOf: [
                        {
                          type: "object",
                          additionalProperties: {
                            nullable: !0
                          }
                        },
                        {
                          type: "object",
                          properties: {
                            index: {
                              type: "integer",
                              minimum: 0
                            }
                          },
                          required: [
                            "index"
                          ]
                        }
                      ]
                    }
                  }
                ],
                description: "the dataset item indexes matching the supplied criteria"
              }
            }
          }
        },
        400: {
          description: "400",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        },
        404: {
          description: "404",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        }
      }
    }
  },
  "/dataset/{datasetId}/item/{datasetItemIdOrIx}": {
    get: {
      description: "Obtains a single dataset item by its ID or its index, and the dataset's ID.",
      summary: "obtains a dataset item by its unique ID",
      tags: [],
      parameters: [
        {
          name: "datasetId",
          in: "path",
          required: !0,
          schema: {
            type: "string",
            pattern: "^[A-Za-z0-9_-]+$"
          },
          description: "uniquely specifies the dataset wanted"
        },
        {
          name: "datasetItemIdOrIx",
          in: "path",
          required: !0,
          schema: {
            type: "string"
          },
          description: "Uniquely specifies the dataset item wanted within the dataset. This param must be base64 encoded. The decoded param should start with an @ to indicate an index, otherwise it is assumed to be an id"
        }
      ],
      operationId: "getDatasetItem",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                allOf: [
                  {
                    allOf: [
                      {
                        type: "object",
                        properties: {
                          id: {
                            type: "string"
                          }
                        },
                        required: [
                          "id"
                        ]
                      },
                      {
                        type: "object",
                        additionalProperties: {
                          nullable: !0
                        }
                      }
                    ]
                  },
                  {
                    type: "object",
                    properties: {
                      index: {
                        type: "integer",
                        minimum: 0
                      }
                    },
                    required: [
                      "index"
                    ]
                  }
                ],
                description: "the dataset item matching the supplied ID or index"
              }
            }
          }
        },
        400: {
          description: "400",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        },
        404: {
          description: "404",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        }
      }
    }
  },
  "/dataset/{datasetId}/totals": {
    get: {
      description: "Gets the total number of results under each item in the directory.",
      summary: "get the total number of results under each item in the directory",
      tags: [],
      parameters: [
        {
          name: "datasetId",
          in: "path",
          required: !0,
          schema: {
            type: "string",
            pattern: "^[A-Za-z0-9_-]+$"
          },
          description: "uniquely specifies the dataset wanted"
        }
      ],
      operationId: "getTotals",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                type: "object",
                additionalProperties: {
                  type: "number"
                },
                description: "the total result numbers for a map"
              }
            }
          }
        },
        400: {
          description: "400",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        },
        404: {
          description: "404",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        }
      }
    }
  },
  "/dataset/{datasetId}/config": {
    get: {
      description: "Obtains configured parameters for a datset, which amongst other things, include default values for various options, and definitions of vocabulary terms with their localised labels, that are used to interpret identifers in the data and/or elsewhere.",
      summary: "obtain various configured parameters for a dataset",
      tags: [],
      parameters: [
        {
          name: "datasetId",
          in: "path",
          required: !0,
          schema: {
            type: "string",
            pattern: "^[A-Za-z0-9_-]+$"
          },
          description: "uniquely specifies the dataset wanted"
        }
      ],
      operationId: "getConfig",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  prefixes: {
                    type: "object",
                    additionalProperties: {
                      type: "string"
                    }
                  },
                  vocabs: {
                    type: "object",
                    additionalProperties: {
                      type: "object",
                      additionalProperties: {
                        type: "object",
                        properties: {
                          title: {
                            type: "string"
                          },
                          terms: {
                            type: "object",
                            additionalProperties: {
                              type: "string"
                            }
                          }
                        },
                        required: [
                          "title",
                          "terms"
                        ]
                      }
                    }
                  },
                  itemProps: {
                    allOf: [
                      {
                        type: "object",
                        properties: {
                          id: {
                            type: "object",
                            properties: {
                              from: {
                                type: "string"
                              },
                              titleUri: {
                                type: "string"
                              },
                              filter: {
                                type: "boolean",
                                enum: [
                                  !1
                                ]
                              },
                              search: {
                                type: "boolean"
                              },
                              type: {
                                type: "string",
                                enum: [
                                  "value"
                                ]
                              },
                              as: {
                                type: "string",
                                enum: [
                                  "string",
                                  "boolean",
                                  "number"
                                ]
                              },
                              strict: {
                                type: "boolean"
                              },
                              nullable: {
                                type: "boolean"
                              }
                            },
                            required: [
                              "type"
                            ]
                          }
                        },
                        required: [
                          "id"
                        ]
                      },
                      {
                        type: "object",
                        additionalProperties: {
                          discriminator: {
                            propertyName: "type"
                          },
                          oneOf: [
                            {
                              type: "object",
                              properties: {
                                from: {
                                  type: "string"
                                },
                                titleUri: {
                                  type: "string"
                                },
                                filter: {
                                  oneOf: [
                                    {
                                      type: "object",
                                      properties: {
                                        preset: {
                                          type: "boolean",
                                          enum: [
                                            !0
                                          ]
                                        },
                                        to: {
                                          nullable: !0
                                        }
                                      },
                                      required: [
                                        "preset"
                                      ]
                                    },
                                    {
                                      type: "boolean"
                                    }
                                  ]
                                },
                                search: {
                                  type: "boolean"
                                },
                                type: {
                                  type: "string",
                                  enum: [
                                    "value"
                                  ]
                                },
                                as: {
                                  type: "string",
                                  enum: [
                                    "string",
                                    "boolean",
                                    "number"
                                  ]
                                },
                                strict: {
                                  type: "boolean"
                                },
                                nullable: {
                                  type: "boolean"
                                }
                              },
                              required: [
                                "type"
                              ]
                            },
                            {
                              type: "object",
                              properties: {
                                from: {
                                  type: "string"
                                },
                                titleUri: {
                                  type: "string"
                                },
                                filter: {
                                  oneOf: [
                                    {
                                      type: "object",
                                      properties: {
                                        preset: {
                                          type: "boolean",
                                          enum: [
                                            !0
                                          ]
                                        },
                                        to: {
                                          nullable: !0
                                        }
                                      },
                                      required: [
                                        "preset"
                                      ]
                                    },
                                    {
                                      type: "boolean"
                                    }
                                  ]
                                },
                                search: {
                                  type: "boolean"
                                },
                                type: {
                                  type: "string",
                                  enum: [
                                    "vocab"
                                  ]
                                },
                                uri: {
                                  type: "string"
                                },
                                sorted: {
                                  oneOf: [
                                    {
                                      type: "boolean"
                                    },
                                    {
                                      type: "string",
                                      enum: [
                                        "asc"
                                      ]
                                    },
                                    {
                                      type: "string",
                                      enum: [
                                        "desc"
                                      ]
                                    }
                                  ]
                                }
                              },
                              required: [
                                "type",
                                "uri"
                              ]
                            },
                            {
                              type: "object",
                              properties: {
                                from: {
                                  type: "string"
                                },
                                titleUri: {
                                  type: "string"
                                },
                                filter: {
                                  oneOf: [
                                    {
                                      type: "object",
                                      properties: {
                                        preset: {
                                          type: "boolean",
                                          enum: [
                                            !0
                                          ]
                                        },
                                        to: {
                                          nullable: !0
                                        }
                                      },
                                      required: [
                                        "preset"
                                      ]
                                    },
                                    {
                                      type: "boolean"
                                    }
                                  ]
                                },
                                search: {
                                  type: "boolean"
                                },
                                type: {
                                  type: "string",
                                  enum: [
                                    "multi"
                                  ]
                                },
                                of: {
                                  oneOf: [
                                    {
                                      type: "object",
                                      properties: {
                                        type: {
                                          type: "string",
                                          enum: [
                                            "value"
                                          ]
                                        },
                                        as: {
                                          type: "string",
                                          enum: [
                                            "string",
                                            "boolean",
                                            "number"
                                          ]
                                        },
                                        strict: {
                                          type: "boolean"
                                        },
                                        nullable: {
                                          type: "boolean"
                                        }
                                      },
                                      required: [
                                        "type"
                                      ]
                                    },
                                    {
                                      type: "object",
                                      properties: {
                                        type: {
                                          type: "string",
                                          enum: [
                                            "vocab"
                                          ]
                                        },
                                        uri: {
                                          type: "string"
                                        },
                                        sorted: {
                                          oneOf: [
                                            {
                                              type: "boolean"
                                            },
                                            {
                                              type: "string",
                                              enum: [
                                                "asc"
                                              ]
                                            },
                                            {
                                              type: "string",
                                              enum: [
                                                "desc"
                                              ]
                                            }
                                          ]
                                        }
                                      },
                                      required: [
                                        "type",
                                        "uri"
                                      ]
                                    }
                                  ]
                                }
                              },
                              required: [
                                "type",
                                "of"
                              ]
                            }
                          ]
                        }
                      }
                    ]
                  },
                  languages: {
                    type: "array",
                    items: {
                      type: "string",
                      enum: [
                        "aa",
                        "ab",
                        "ae",
                        "af",
                        "ak",
                        "am",
                        "an",
                        "ar",
                        "as",
                        "av",
                        "ay",
                        "az",
                        "ba",
                        "be",
                        "bg",
                        "bi",
                        "bm",
                        "bn",
                        "bo",
                        "br",
                        "bs",
                        "ca",
                        "ce",
                        "ch",
                        "co",
                        "cr",
                        "cs",
                        "cu",
                        "cv",
                        "cy",
                        "da",
                        "de",
                        "dv",
                        "dz",
                        "ee",
                        "el",
                        "en",
                        "eo",
                        "es",
                        "et",
                        "eu",
                        "fa",
                        "ff",
                        "fi",
                        "fj",
                        "fo",
                        "fr",
                        "fy",
                        "ga",
                        "gd",
                        "gl",
                        "gn",
                        "gu",
                        "gv",
                        "ha",
                        "he",
                        "hi",
                        "ho",
                        "hr",
                        "ht",
                        "hu",
                        "hy",
                        "hz",
                        "ia",
                        "id",
                        "ie",
                        "ig",
                        "ii",
                        "ik",
                        "io",
                        "is",
                        "it",
                        "iu",
                        "ja",
                        "jv",
                        "ka",
                        "kg",
                        "ki",
                        "kj",
                        "kk",
                        "kl",
                        "km",
                        "kn",
                        "ko",
                        "kr",
                        "ks",
                        "ku",
                        "kv",
                        "kw",
                        "ky",
                        "la",
                        "lb",
                        "lg",
                        "li",
                        "ln",
                        "lo",
                        "lt",
                        "lu",
                        "lv",
                        "mg",
                        "mh",
                        "mi",
                        "mk",
                        "ml",
                        "mn",
                        "mr",
                        "ms",
                        "mt",
                        "my",
                        "na",
                        "nb",
                        "nd",
                        "ne",
                        "ng",
                        "nl",
                        "nn",
                        "no",
                        "nr",
                        "nv",
                        "ny",
                        "oc",
                        "oj",
                        "om",
                        "or",
                        "os",
                        "pa",
                        "pi",
                        "pl",
                        "ps",
                        "pt",
                        "qu",
                        "rm",
                        "rn",
                        "ro",
                        "ru",
                        "rw",
                        "sa",
                        "sc",
                        "sd",
                        "se",
                        "sg",
                        "si",
                        "sk",
                        "sl",
                        "sm",
                        "sn",
                        "so",
                        "sq",
                        "sr",
                        "ss",
                        "st",
                        "su",
                        "sv",
                        "sw",
                        "ta",
                        "te",
                        "tg",
                        "th",
                        "ti",
                        "tk",
                        "tl",
                        "tn",
                        "to",
                        "tr",
                        "ts",
                        "tt",
                        "tw",
                        "ty",
                        "ug",
                        "uk",
                        "ur",
                        "uz",
                        "ve",
                        "vi",
                        "vo",
                        "wa",
                        "wo",
                        "xh",
                        "yi",
                        "yo",
                        "za",
                        "zh",
                        "zu"
                      ]
                    },
                    minItems: 1
                  },
                  ui: {
                    type: "object",
                    properties: {
                      directory_panel_field: {
                        type: "string"
                      },
                      marker_property_name: {
                        type: "string"
                      },
                      map: {
                        type: "object",
                        properties: {
                          mapBounds: {
                            type: "array",
                            items: {
                              type: "array",
                              items: {
                                type: "number"
                              }
                            },
                            minItems: 2,
                            maxItems: 2
                          }
                        }
                      },
                      logo: {
                        type: "object",
                        properties: {
                          largeLogo: {
                            type: "string"
                          },
                          smallLogo: {
                            type: "string"
                          },
                          altText: {
                            type: "string"
                          },
                          smallScreenPosition: {
                            type: "object",
                            properties: {
                              top: {
                                type: "string"
                              },
                              left: {
                                type: "string"
                              }
                            }
                          },
                          largeScreenPosition: {
                            type: "object",
                            properties: {
                              bottom: {
                                type: "string"
                              },
                              right: {
                                type: "string"
                              }
                            }
                          }
                        }
                      }
                    },
                    required: [
                      "directory_panel_field"
                    ]
                  },
                  popup: {
                    type: "object",
                    properties: {
                      titleProp: {
                        type: "string"
                      },
                      leftPaneWidth: {
                        default: "70%",
                        type: "string"
                      },
                      leftPane: {
                        type: "array",
                        items: {
                          type: "object",
                          properties: {
                            itemProp: {
                              type: "string"
                            },
                            valueStyle: {
                              default: "text",
                              type: "string",
                              enum: [
                                "text",
                                "address",
                                "hyperlink"
                              ]
                            },
                            showBullets: {
                              default: !1,
                              type: "boolean"
                            },
                            singleColumnLimit: {
                              type: "number"
                            },
                            showLabel: {
                              default: !1,
                              type: "boolean"
                            },
                            hyperlinkBaseUri: {
                              default: "",
                              type: "string"
                            },
                            displayText: {
                              type: "string"
                            }
                          },
                          required: [
                            "itemProp"
                          ]
                        }
                      },
                      topRightPane: {
                        type: "array",
                        items: {
                          type: "object",
                          properties: {
                            itemProp: {
                              type: "string"
                            },
                            valueStyle: {
                              default: "text",
                              type: "string",
                              enum: [
                                "text",
                                "address",
                                "hyperlink"
                              ]
                            },
                            showBullets: {
                              default: !1,
                              type: "boolean"
                            },
                            singleColumnLimit: {
                              type: "number"
                            },
                            showLabel: {
                              default: !1,
                              type: "boolean"
                            },
                            hyperlinkBaseUri: {
                              default: "",
                              type: "string"
                            },
                            displayText: {
                              type: "string"
                            }
                          },
                          required: [
                            "itemProp"
                          ]
                        }
                      },
                      bottomRightPane: {
                        type: "array",
                        items: {
                          type: "object",
                          properties: {
                            itemProp: {
                              type: "string"
                            },
                            valueStyle: {
                              default: "text",
                              type: "string",
                              enum: [
                                "text",
                                "address",
                                "hyperlink"
                              ]
                            },
                            showBullets: {
                              default: !1,
                              type: "boolean"
                            },
                            singleColumnLimit: {
                              type: "number"
                            },
                            showLabel: {
                              default: !1,
                              type: "boolean"
                            },
                            hyperlinkBaseUri: {
                              default: "",
                              type: "string"
                            },
                            displayText: {
                              type: "string"
                            }
                          },
                          required: [
                            "itemProp"
                          ]
                        }
                      }
                    },
                    required: [
                      "titleProp",
                      "leftPane",
                      "topRightPane",
                      "bottomRightPane"
                    ]
                  }
                },
                required: [
                  "prefixes",
                  "vocabs",
                  "itemProps",
                  "languages",
                  "ui",
                  "popup"
                ],
                description: "various configured parameters for a map"
              }
            }
          }
        },
        400: {
          description: "400",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        },
        404: {
          description: "404",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        }
      }
    }
  },
  "/dataset/{datasetId}/about": {
    get: {
      description: "Obtains information about the datset, in markdown format so it can be easily rendered on a front-end application.",
      summary: "obtain the About text for a dataset",
      tags: [],
      parameters: [
        {
          name: "datasetId",
          in: "path",
          required: !0,
          schema: {
            type: "string",
            pattern: "^[A-Za-z0-9_-]+$"
          },
          description: "uniquely specifies the dataset wanted"
        }
      ],
      operationId: "getAbout",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                type: "string",
                description: "About text in markdown format"
              }
            }
          }
        },
        400: {
          description: "400",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        },
        404: {
          description: "404",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  message: {
                    type: "string"
                  }
                },
                required: [
                  "message"
                ],
                additionalProperties: !0,
                description: "no such dataset"
              }
            }
          }
        }
      }
    }
  },
  "/version": {
    get: {
      description: "Obtains version information about the backend Mykomap server, in the form of a JSON object",
      summary: "obtains Mykomap server version information",
      tags: [],
      parameters: [],
      operationId: "getVersion",
      responses: {
        200: {
          description: "200",
          content: {
            "application/json": {
              schema: {
                type: "object",
                properties: {
                  name: {
                    type: "string"
                  },
                  buildTime: {
                    type: "string",
                    format: "date-time"
                  },
                  version: {},
                  commitDesc: {
                    type: "string"
                  },
                  nodeEnv: {
                    type: "string"
                  }
                },
                required: [
                  "name",
                  "buildTime",
                  "version",
                  "commitDesc",
                  "nodeEnv"
                ],
                description: "information about the current Mykomap server build"
              }
            }
          }
        }
      }
    }
  }
}, Ne = {
  title: "Mykomap basic data and search API",
  description: "This is a basic API for Mykomap application clients",
  contact: {
    email: "hello@digitalcommons.coop"
  },
  license: {
    name: "Apache 2.0",
    url: "http://www.apache.org/licenses/LICENSE-2.0.html"
  },
  version: "0.1.0"
}, _t = {
  openapi: De,
  paths: qe,
  info: Ne
}, h = /* @__PURE__ */ (() => {
  const e = (o) => o instanceof RegExp ? o.source : o, t = (o, ...u) => {
    switch (u.length) {
      case 0:
        return "";
      case 1:
        return `(?:${e(u[0])})`;
      default:
        return "(?:" + u.map((b) => `(?:${e(b)})`).join(o) + ")";
    }
  };
  return { conc: (...o) => new RegExp(o.map((u) => e(u)).join("")), maybe: (...o) => {
    const u = t("|", ...o);
    return new RegExp(`${u}?`);
  }, min: (o, ...u) => {
    const b = t("|", ...u);
    switch (o) {
      case 0:
        return new RegExp(`${b}*`);
      case 1:
        return new RegExp(`${b}+`);
    }
  }, seq: (...o) => new RegExp(t("", ...o)), oneOf: (...o) => new RegExp(t("|", ...o)), uaon: (o) => {
    let [u, b] = o instanceof RegExp ? [o.source, o.flags] : [o, ""];
    return u = u.replace(/^\^?/ms, "^"), u = u.replace(/\$?$/ms, "$"), b = [...new Set((b + "msu").split(""))].join(""), new RegExp(u, b);
  }, wrap: (o, ...u) => new RegExp(t(o, ...u)) };
})();
var k = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, X = {}, v = {}, U = {};
Object.defineProperty(U, "__esModule", { value: !0 });
const V = (e) => {
  if (typeof e == "object" && e !== null) {
    if (typeof Object.getPrototypeOf == "function") {
      const t = Object.getPrototypeOf(e);
      return t === Object.prototype || t === null;
    }
    return Object.prototype.toString.call(e) === "[object Object]";
  }
  return !1;
}, y = (...e) => e.reduce((t, i) => {
  if (Array.isArray(i))
    throw new TypeError("Arguments provided to ts-deepmerge must be objects, not arrays.");
  return Object.keys(i).forEach((a) => {
    ["__proto__", "constructor", "prototype"].includes(a) || (Array.isArray(t[a]) && Array.isArray(i[a]) ? t[a] = y.options.mergeArrays ? y.options.uniqueArrayItems ? Array.from(new Set(t[a].concat(i[a]))) : [...t[a], ...i[a]] : i[a] : V(t[a]) && V(i[a]) ? t[a] = y(t[a], i[a]) : t[a] = i[a] === void 0 ? y.options.allowUndefinedOverrides ? i[a] : t[a] : i[a]);
  }), t;
}, {}), E = {
  allowUndefinedOverrides: !0,
  mergeArrays: !0,
  uniqueArrayItems: !0
};
y.options = E;
y.withOptions = (e, ...t) => {
  y.options = Object.assign(Object.assign({}, E), e);
  const i = y(...t);
  return y.options = E, i;
};
U.default = y;
Object.defineProperty(v, "__esModule", { value: !0 });
v.generateSchema = v.extendApi = void 0;
const p = U, _ = Ae;
function Se(e, t = {}) {
  return e.metaOpenApi = Object.assign(e.metaOpenApi || {}, t), e;
}
v.extendApi = Se;
function Te({ zodRef: e, useOutput: t }) {
  return Object.keys(e.shape).reduce((i, a) => Object.assign(Object.assign({}, i), { [a]: l(e.shape[a], t) }), {});
}
function F({ zodRef: e, schemas: t, useOutput: i }) {
  const a = l(e._def.schema, i);
  let r = "undefined";
  if (i && e._def.effect) {
    const s = e._def.effect.type === "transform" ? e._def.effect : null;
    if (s && "transform" in s)
      try {
        r = typeof s.transform(
          ["integer", "number"].includes(`${a.type}`) ? 0 : a.type === "string" ? "" : a.type === "boolean" ? !1 : a.type === "object" ? {} : a.type === "null" ? null : a.type === "array" ? [] : void 0,
          { addIssue: () => {
          }, path: [] }
          // TODO: Discover if context is necessary here
        );
      } catch {
      }
  }
  return (0, p.default)(Object.assign(Object.assign(Object.assign({}, e.description ? { description: e.description } : {}), a), ["number", "string", "boolean", "null"].includes(r) ? {
    type: r
  } : {}), ...t);
}
function Ze({ zodRef: e, schemas: t }) {
  const i = {
    type: "string"
  }, { checks: a = [] } = e._def;
  return a.forEach((r) => {
    switch (r.kind) {
      case "email":
        i.format = "email";
        break;
      case "uuid":
        i.format = "uuid";
        break;
      case "cuid":
        i.format = "cuid";
        break;
      case "url":
        i.format = "uri";
        break;
      case "datetime":
        i.format = "date-time";
        break;
      case "length":
        i.minLength = r.value, i.maxLength = r.value;
        break;
      case "max":
        i.maxLength = r.value;
        break;
      case "min":
        i.minLength = r.value;
        break;
      case "regex":
        i.pattern = r.regex.source;
        break;
    }
  }), (0, p.default)(i, e.description ? { description: e.description } : {}, ...t);
}
function Ee({ zodRef: e, schemas: t }) {
  const i = {
    type: "number"
  }, { checks: a = [] } = e._def;
  return a.forEach((r) => {
    switch (r.kind) {
      case "max":
        i.maximum = r.value, r.inclusive || (i.exclusiveMaximum = r.value);
        break;
      case "min":
        i.minimum = r.value, r.inclusive || (i.exclusiveMinimum = r.value);
        break;
      case "int":
        i.type = "integer";
        break;
      case "multipleOf":
        i.multipleOf = r.value;
    }
  }), (0, p.default)(i, e.description ? { description: e.description } : {}, ...t);
}
function Le({ zodRef: e, schemas: t, useOutput: i }) {
  var a;
  let r;
  e._def.catchall instanceof _.z.ZodNever || ((a = e._def.catchall) === null || a === void 0 ? void 0 : a._def.typeName) === "ZodNever" ? e._def.unknownKeys === "passthrough" ? r = !0 : e._def.unknownKeys === "strict" && (r = !1) : r = l(e._def.catchall, i), r = r != null ? { additionalProperties: r } : {};
  const s = Object.keys(e.shape).filter((m) => {
    const I = e.shape[m];
    return !(I.isOptional() || I instanceof _.z.ZodDefault || I._def.typeName === "ZodDefault") && !(I instanceof _.z.ZodNever || I._def.typeName === "ZodDefault");
  }), c = s.length > 0 ? { required: s } : {};
  return (0, p.default)(Object.assign(Object.assign({ type: "object", properties: Te({
    zodRef: e,
    schemas: t,
    useOutput: i
  }) }, c), r), e.description ? { description: e.description } : {}, ...t);
}
function Ue({ zodRef: e, schemas: t, useOutput: i }) {
  return (0, p.default)({
    type: "object",
    additionalProperties: e._def.valueType instanceof _.z.ZodUnknown ? {} : l(e._def.valueType, i)
  }, e.description ? { description: e.description } : {}, ...t);
}
function Me({ zodRef: e, schemas: t }) {
  return (0, p.default)({ type: "integer", format: "int64" }, e.description ? { description: e.description } : {}, ...t);
}
function Be({ zodRef: e, schemas: t }) {
  return (0, p.default)({ type: "boolean" }, e.description ? { description: e.description } : {}, ...t);
}
function $e({ zodRef: e, schemas: t }) {
  return (0, p.default)({ type: "string", format: "date-time" }, e.description ? { description: e.description } : {}, ...t);
}
function Ce({ zodRef: e, schemas: t }) {
  return (0, p.default)({
    type: "string",
    format: "null",
    nullable: !0
  }, e.description ? { description: e.description } : {}, ...t);
}
function G({ schemas: e, zodRef: t, useOutput: i }) {
  return (0, p.default)(l(t.unwrap(), i), t.description ? { description: t.description } : {}, ...e);
}
function Ve({ schemas: e, zodRef: t, useOutput: i }) {
  return (0, p.default)(Object.assign({ default: t._def.defaultValue() }, l(t._def.innerType, i)), t.description ? { description: t.description } : {}, ...e);
}
function Fe({ schemas: e, zodRef: t, useOutput: i }) {
  const a = {};
  return t._def.exactLength != null && (a.minItems = t._def.exactLength.value, a.maxItems = t._def.exactLength.value), t._def.minLength != null && (a.minItems = t._def.minLength.value), t._def.maxLength != null && (a.maxItems = t._def.maxLength.value), (0, p.default)(Object.assign({ type: "array", items: l(t.element, i) }, a), t.description ? { description: t.description } : {}, ...e);
}
function Ge({ schemas: e, zodRef: t }) {
  return (0, p.default)({
    type: typeof t._def.value,
    enum: [t._def.value]
  }, t.description ? { description: t.description } : {}, ...e);
}
function K({ schemas: e, zodRef: t }) {
  return (0, p.default)({
    type: typeof Object.values(t._def.values)[0],
    enum: Object.values(t._def.values)
  }, t.description ? { description: t.description } : {}, ...e);
}
function Ke({ schemas: e, zodRef: t, useOutput: i }) {
  return (0, p.default)({
    allOf: [
      l(t._def.left, i),
      l(t._def.right, i)
    ]
  }, t.description ? { description: t.description } : {}, ...e);
}
function We({ schemas: e, zodRef: t, useOutput: i }) {
  const a = t._def.options;
  if (a.reduce((r, s) => r && s._def.typeName === "ZodLiteral", !0)) {
    const r = a, s = r.reduce((c, m) => !c || c === typeof m._def.value ? typeof m._def.value : null, null);
    if (s)
      return (0, p.default)({
        type: s,
        enum: r.map((c) => c._def.value)
      }, t.description ? { description: t.description } : {}, ...e);
  }
  return (0, p.default)({
    oneOf: a.map((r) => l(r, i))
  }, t.description ? { description: t.description } : {}, ...e);
}
function He({ schemas: e, zodRef: t, useOutput: i }) {
  return (0, p.default)({
    discriminator: {
      propertyName: t._def.discriminator
    },
    oneOf: Array.from(t._def.options.values()).map((a) => l(a, i))
  }, t.description ? { description: t.description } : {}, ...e);
}
function Qe({ zodRef: e, schemas: t }) {
  return (0, p.default)({ readOnly: !0 }, e.description ? { description: e.description } : {}, ...t);
}
function Je({ schemas: e, zodRef: t }) {
  return (0, p.default)(l(t._def.type), ...e);
}
function f({ zodRef: e, schemas: t }) {
  return (0, p.default)(e.description ? { description: e.description } : {}, ...t);
}
const W = {
  ZodObject: Le,
  ZodRecord: Ue,
  ZodString: Ze,
  ZodNumber: Ee,
  ZodBigInt: Me,
  ZodBoolean: Be,
  ZodDate: $e,
  ZodNull: Ce,
  ZodOptional: G,
  ZodNullable: G,
  ZodDefault: Ve,
  ZodArray: Fe,
  ZodLiteral: Ge,
  ZodEnum: K,
  ZodNativeEnum: K,
  ZodTransformer: F,
  ZodEffects: F,
  ZodIntersection: Ke,
  ZodUnion: We,
  ZodDiscriminatedUnion: He,
  ZodNever: Qe,
  ZodBranded: Je,
  // TODO Transform the rest to schemas
  ZodUndefined: f,
  // TODO: `prefixItems` is allowed in OpenAPI 3.1 which can be used to create tuples
  ZodTuple: f,
  ZodMap: f,
  ZodFunction: f,
  ZodLazy: f,
  ZodPromise: f,
  ZodAny: f,
  ZodUnknown: f,
  ZodVoid: f
};
function l(e, t) {
  const { metaOpenApi: i = {} } = e, a = [
    e.isNullable && e.isNullable() ? { nullable: !0 } : {},
    ...Array.isArray(i) ? i : [i]
  ];
  try {
    const r = e._def.typeName;
    return r in W ? W[r]({
      zodRef: e,
      schemas: a,
      useOutput: t
    }) : f({ zodRef: e, schemas: a });
  } catch (r) {
    return console.error(r), f({ zodRef: e, schemas: a });
  }
}
v.generateSchema = l;
var S = {};
Object.defineProperty(S, "__esModule", { value: !0 });
S.extendZodWithOpenApi = void 0;
const Ye = v;
function Xe(e, t = !1) {
  !t && typeof e.ZodSchema.prototype.openapi < "u" || (e.ZodSchema.prototype.openapi = function(i) {
    return (0, Ye.extendApi)(this, i);
  });
}
S.extendZodWithOpenApi = Xe;
(function(e) {
  var t = k && k.__createBinding || (Object.create ? function(a, r, s, c) {
    c === void 0 && (c = s);
    var m = Object.getOwnPropertyDescriptor(r, s);
    (!m || ("get" in m ? !r.__esModule : m.writable || m.configurable)) && (m = { enumerable: !0, get: function() {
      return r[s];
    } }), Object.defineProperty(a, c, m);
  } : function(a, r, s, c) {
    c === void 0 && (c = s), a[c] = r[s];
  }), i = k && k.__exportStar || function(a, r) {
    for (var s in a) s !== "default" && !Object.prototype.hasOwnProperty.call(r, s) && t(r, a, s);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), i(v, e), i(S, e);
})(X);
const { min: w, seq: P, conc: ze, maybe: z, oneOf: At } = h, Re = /^[A-Za-z0-9_-]+$/imsu, O = /(?:[_\p{Ll}\p{Lu}\p{Lt}\p{Lo}\p{Nl}][_.\p{L}\p{M}\p{Nd}\p{Nl}-]*)/imsu, R = new RegExp(`${O.source}[:]${O.source}`, "imsu"), ee = new RegExp(`${O.source}[:]`, "imsu"), et = /https?:\/\//, L = /[A-Za-z](?:[A-Za-z0-9-]*[A-Za-z0-9])?/, tt = P(L, w(0, P("[.]", L))), D = /%[0-9A-Fa-f]{2}/, te = /[A-Za-z0-9._~!$&'()*+,;=:@-]/, ne = w(1, D, te), nt = P(w(0, P("/", ne)), z("/")), ie = ze(et, tt, nt, z("#")), it = /[A-Za-z0-9._~!$&'()*+,;=:-]/, ae = P(
  w(1, D, it),
  w(0, D, te)
), re = P(/@/, w(1, /\d/)), at = ne, rt = {
  NCName: h.uaon(O),
  QName: h.uaon(R),
  AbbrevUri: h.uaon(ee),
  DomainLabel: h.uaon(L),
  PctEnc: h.uaon(D),
  PrefixUri: h.uaon(ie),
  DatasetItemId: h.uaon(ae),
  DatasetItemIx: h.uaon(re)
};
function Dt(e = "", t) {
  if (rt.AbbrevUri.test(e)) {
    const [i, a] = e.split(":");
    return i;
  }
  if (t === void 0)
    throw new Error(`invalid AbbrevUri: '${e}'`);
  return t;
}
const st = {
  // ISO 639-1 code: "English Name of Language"
  aa: "Afar",
  ab: "Abkhazian",
  ae: "Avestan",
  af: "Afrikaans",
  ak: "Akan",
  am: "Amharic",
  an: "Aragonese",
  ar: "Arabic",
  as: "Assamese",
  av: "Avaric",
  ay: "Aymara",
  az: "Azerbaijani",
  ba: "Bashkir",
  be: "Belarusian",
  bg: "Bulgarian",
  bi: "Bislama",
  bm: "Bambara",
  bn: "Bengali",
  bo: "Tibetan",
  br: "Breton",
  bs: "Bosnian",
  ca: "Catalan",
  //ca: "Valencian",
  ce: "Chechen",
  ch: "Chamorro",
  co: "Corsican",
  cr: "Cree",
  cs: "Czech",
  cu: "Church Slavic",
  //cu: "Church Slavonic",
  //cu: "Old Bulgarian",
  //cu: "Old Church Slavonic",
  //cu: "Old Slavonic",
  cv: "Chuvash",
  cy: "Welsh",
  da: "Danish",
  de: "German",
  //dv: "Dhivehi",
  //dv: "Divehi",
  dv: "Maldivian",
  dz: "Dzongkha",
  ee: "Ewe",
  el: "Greek, Modern (1453-)",
  en: "English",
  eo: "Esperanto",
  //es: "Castilian",
  es: "Spanish",
  et: "Estonian",
  eu: "Basque",
  fa: "Persian",
  ff: "Fulah",
  fi: "Finnish",
  fj: "Fijian",
  fo: "Faroese",
  fr: "French",
  fy: "Western Frisian",
  ga: "Irish",
  //gd: "Gaelic",
  gd: "Scottish Gaelic",
  gl: "Galician",
  gn: "Guarani",
  gu: "Gujarati",
  gv: "Manx",
  ha: "Hausa",
  he: "Hebrew",
  hi: "Hindi",
  ho: "Hiri Motu",
  hr: "Croatian",
  //ht: "Haitian Creole",
  ht: "Haitian",
  hu: "Hungarian",
  hy: "Armenian",
  hz: "Herero",
  ia: "Interlingua (International Auxiliary Language Association)",
  id: "Indonesian",
  ie: "Interlingue",
  //ie: "Occidental",
  ig: "Igbo",
  //ii: "Nuosu",
  ii: "Sichuan Yi",
  ik: "Inupiaq",
  io: "Ido",
  is: "Icelandic",
  it: "Italian",
  iu: "Inuktitut",
  ja: "Japanese",
  jv: "Javanese",
  ka: "Georgian",
  kg: "Kongo",
  //ki: "Gikuyu",
  ki: "Kikuyu",
  kj: "Kuanyama",
  //kj: "Kwanyama",
  kk: "Kazakh",
  kl: "Greenlandic",
  //kl: "Kalaallisut",
  km: "Central Khmer",
  kn: "Kannada",
  ko: "Korean",
  kr: "Kanuri",
  ks: "Kashmiri",
  ku: "Kurdish",
  kv: "Komi",
  kw: "Cornish",
  //ky: "Kirghiz",
  ky: "Kyrgyz",
  la: "Latin",
  //lb: "Letzeburgesch",
  lb: "Luxembourgish",
  lg: "Ganda",
  li: "Limburgan",
  //li: "Limburger",
  //li: "Limburgish",
  ln: "Lingala",
  lo: "Lao",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  lv: "Latvian",
  mg: "Malagasy",
  mh: "Marshallese",
  mi: "Maori",
  mk: "Macedonian",
  ml: "Malayalam",
  mn: "Mongolian",
  mr: "Marathi",
  ms: "Malay",
  mt: "Maltese",
  my: "Burmese",
  na: "Nauru",
  //nb: "Bokmål, Norwegian",
  nb: "Norwegian Bokmål",
  //nd: "Ndebele, North",
  nd: "North Ndebele",
  ne: "Nepali",
  ng: "Ndonga",
  nl: "Dutch",
  //nl: "Flemish",
  nn: "Norwegian Nynorsk",
  //nn: "Nynorsk, Norwegian",
  no: "Norwegian",
  //nr: "Ndebele, South",
  nr: "South Ndebele",
  //nv: "Navaho",
  nv: "Navajo",
  ny: "Chewa",
  //ny: "Chichewa",
  //ny: "Nyanja",
  oc: "Occitan (post 1500)",
  oj: "Ojibwa",
  om: "Oromo",
  or: "Oriya",
  os: "Ossetian",
  //os: "Ossetic",
  //pa: "Panjabi",
  pa: "Punjabi",
  pi: "Pali",
  pl: "Polish",
  ps: "Pashto",
  //ps: "Pushto",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  //ro: "Moldavian",
  //ro: "Moldovan",
  ro: "Romanian",
  ru: "Russian",
  rw: "Kinyarwanda",
  sa: "Sanskrit",
  sc: "Sardinian",
  sd: "Sindhi",
  se: "Northern Sami",
  sg: "Sango",
  //si: "Sinhala",
  si: "Sinhalese",
  sk: "Slovak",
  sl: "Slovenian",
  sm: "Samoan",
  sn: "Shona",
  so: "Somali",
  sq: "Albanian",
  sr: "Serbian",
  ss: "Swati",
  st: "Sotho, Southern",
  su: "Sundanese",
  sv: "Swedish",
  sw: "Swahili",
  ta: "Tamil",
  te: "Telugu",
  tg: "Tajik",
  th: "Thai",
  ti: "Tigrinya",
  tk: "Turkmen",
  tl: "Tagalog",
  tn: "Tswana",
  to: "Tonga (Tonga Islands)",
  tr: "Turkish",
  ts: "Tsonga",
  tt: "Tatar",
  tw: "Twi",
  ty: "Tahitian",
  ug: "Uighur",
  //ug: "Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volapük",
  wa: "Walloon",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  //za: "Chuang",
  za: "Zhuang",
  zh: "Chinese",
  zu: "Zulu"
};
X.extendZodWithOpenApi(n);
const ot = _e();
function j(e, t) {
  return n.string().refine((i) => h.uaon(e).test(String(i)), {
    message: t
  });
}
const se = n.array(n.number()).min(2).max(2), pt = n.number(), g = n.string().regex(Re), oe = n.object({
  id: n.string()
}).and(n.record(n.string(), n.unknown())), pe = n.array(
  se.nullable(),
  pt.nullable()
), T = j(O, "Invalid NCName format"), q = j(R, "Invalid QName format"), ct = j(
  ae,
  "Invalid DatasetItemId format"
), ut = j(
  re,
  "Invalid DatasetItemIx format"
), A = n.number().int().nonnegative(), ce = j(
  at,
  "Invalid DatasetItemIdOrIx format"
), ue = j(ie, "Invalid prefix URI format"), de = n.record(ue, T), le = j(ee, "Invalid abbreviated URI format"), [dt, ...lt] = Object.keys(st), M = n.enum([dt, ...lt]), me = n.object({
  title: n.string(),
  terms: n.record(T, n.string())
}), fe = n.record(M, me), he = n.record(T, fe), ye = n.object({ preset: n.literal(!0), to: n.unknown() }), B = n.object({
  from: n.string().optional(),
  titleUri: q.optional(),
  filter: n.union([ye, n.boolean()]).optional(),
  search: n.boolean().optional()
}), be = n.object({
  type: n.literal("value"),
  as: n.union([n.literal("string"), n.literal("boolean"), n.literal("number")]).optional(),
  strict: n.boolean().optional(),
  nullable: n.boolean().optional()
}), ge = n.object({
  type: n.literal("vocab"),
  uri: le,
  /**
   * Indicates whether the options should be sorted in filter dropdowns.
   * If set to false, no sorting will occur.
   * Sorting is set to 'asc' by default
   * If set to 'asc' or 'desc', the options will be sorted accordingly.
   */
  sorted: n.union([n.boolean(), n.literal("asc"), n.literal("desc")]).optional()
}), mt = n.union([be, ge]), ft = n.object({
  type: n.literal("multi"),
  of: mt
}), $ = B.merge(be), ve = B.merge(ge), je = B.merge(ft), Ie = n.discriminatedUnion("type", [
  $,
  ve,
  je
]), we = n.object({
  // the 'id' itemProp is required, as a non-filterable ValuePropSpec
  id: $.extend({
    filter: n.literal(!1).optional()
  })
}).and(n.record(n.string(), Ie)), Z = n.object({
  itemProp: n.string(),
  valueStyle: n.union([n.literal("text"), n.literal("address"), n.literal("hyperlink")]).default("text"),
  showBullets: n.boolean().default(!1),
  singleColumnLimit: n.number().optional(),
  showLabel: n.boolean().default(!1),
  hyperlinkBaseUri: n.string().default(""),
  displayText: n.string().optional()
}), ht = n.record(n.string(), n.number()), Pe = n.object({
  prefixes: de,
  vocabs: he,
  itemProps: we,
  languages: n.array(M).nonempty(),
  ui: n.object({
    directory_panel_field: n.string(),
    marker_property_name: n.string().optional(),
    map: n.object({
      mapBounds: n.array(n.array(n.number())).length(2).optional()
    }).optional(),
    logo: n.object({
      largeLogo: n.string().optional(),
      smallLogo: n.string().optional(),
      altText: n.string().optional(),
      smallScreenPosition: n.object({
        top: n.string().optional(),
        left: n.string().optional()
      }).optional(),
      largeScreenPosition: n.object({
        bottom: n.string().optional(),
        right: n.string().optional()
      }).optional()
    }).optional()
  }),
  popup: n.object({
    titleProp: n.string(),
    leftPaneWidth: n.string().default("70%"),
    leftPane: n.array(Z),
    topRightPane: n.array(Z),
    bottomRightPane: n.array(Z)
  })
}), Oe = n.object({
  name: n.string(),
  buildTime: n.string().datetime({ offset: !1 }),
  version: n.array(n.number()).min(1).readonly(),
  commitDesc: n.string(),
  nodeEnv: n.string()
}), d = n.object({ message: n.string() }).passthrough(), yt = {
  AbbrevUri: le,
  Location: se,
  ConfigData: Pe,
  DatasetId: g,
  DatasetItemId: ct,
  DatasetItemIdOrIx: ce,
  DatasetItemIx: ut,
  DatasetItemIxRaw: A,
  DatasetItem: oe,
  DatasetLocations: pe,
  FilterSpec: ye,
  I18nVocabDef: fe,
  Iso639Set1Code: M,
  MultiPropSpec: je,
  NCName: T,
  PrefixUri: ue,
  PrefixIndex: de,
  PropSpec: Ie,
  PropSpecs: we,
  QName: q,
  ValuePropSpec: $,
  BuildInfo: Oe,
  VocabDef: me,
  VocabIndex: he,
  VocabPropSpec: ve,
  ErrorInfo: d
}, qt = ot.router({
  getDatasetLocations: {
    method: "GET",
    path: "/dataset/:datasetId/locations",
    summary: "obtains a dataset's locations",
    description: "Obtains all the locations for a dataset by the dataset ID, which by passing in the appropriate options, might be in different formats",
    pathParams: n.object({
      datasetId: g.openapi({
        description: "uniquely specifies the dataset wanted"
      })
    }),
    responses: {
      200: pe.openapi({
        description: "the dataset matching the supplied ID"
      }),
      400: d.openapi({
        description: "bad input parameter"
      }),
      404: d.openapi({
        description: "no such dataset"
      })
    }
  },
  searchDataset: {
    method: "GET",
    path: "/dataset/:datasetId/search",
    summary: "obtains a list of dataset entries satisfying the search criteria supplied",
    description: "Obtains an array of dataset item indexes, which match the search criteria supplied",
    query: n.object({
      text: n.string().optional().openapi({
        description: "a text fragment to match"
      }),
      // Promote singular parameters to arrays (so that a single filter is possible!),
      // see https://github.com/ts-rest/ts-rest/issues/290#issuecomment-1658983510
      filter: n.array(q).or(q.transform((e) => [e])).optional().openapi({
        description: "uniquely specifies the taxonomy filter items wanted"
      }),
      returnProps: n.array(n.string()).optional().openapi({
        description: "The props to return as an array of item objects. If not specified, only an flattened array of indexes is returned."
      }),
      page: n.coerce.number().int().nonnegative().optional().openapi({
        description: "The page number to return. If not specified, all items are returned."
      }),
      pageSize: n.coerce.number().int().positive().optional().openapi({
        description: "The number of items per page. If not specified, all items are returned."
      })
    }),
    pathParams: n.object({
      datasetId: g.openapi({
        description: "uniquely specifies the dataset wanted"
      })
    }),
    responses: {
      200: n.union([
        n.array(A),
        n.array(
          n.record(n.string(), n.unknown()).and(n.object({ index: A }))
        )
      ]).openapi({
        description: "the dataset item indexes matching the supplied criteria"
      }),
      400: d.openapi({
        description: "bad input parameter"
      }),
      404: d.openapi({
        description: "no such dataset"
      })
    }
  },
  getDatasetItem: {
    method: "GET",
    path: "/dataset/:datasetId/item/:datasetItemIdOrIx",
    summary: "obtains a dataset item by its unique ID",
    description: "Obtains a single dataset item by its ID or its index, and the dataset's ID.",
    pathParams: n.object({
      datasetId: g.openapi({
        description: "uniquely specifies the dataset wanted"
      }),
      datasetItemIdOrIx: ce.openapi({
        description: "Uniquely specifies the dataset item wanted within the dataset. This param must be base64 encoded. The decoded param should start with an @ to indicate an index, otherwise it is assumed to be an id"
      })
    }),
    responses: {
      200: oe.and(n.object({ index: A })).openapi({
        description: "the dataset item matching the supplied ID or index"
      }),
      400: d.openapi({
        description: "bad input parameter"
      }),
      404: d.openapi({
        description: "no such dataset or dataset item"
      })
    }
  },
  getTotals: {
    method: "GET",
    path: "/dataset/:datasetId/totals",
    summary: "get the total number of results under each item in the directory",
    description: "Gets the total number of results under each item in the directory.",
    pathParams: n.object({
      datasetId: g.openapi({
        description: "uniquely specifies the dataset wanted"
      })
    }),
    responses: {
      200: ht.openapi({
        description: "the total result numbers for a map"
      }),
      400: d.openapi({
        description: "bad input parameter"
      }),
      404: d.openapi({
        description: "no such dataset"
      })
    }
  },
  getConfig: {
    method: "GET",
    path: "/dataset/:datasetId/config",
    summary: "obtain various configured parameters for a dataset",
    description: "Obtains configured parameters for a datset, which amongst other things, include default values for various options, and definitions of vocabulary terms with their localised labels, that are used to interpret identifers in the data and/or elsewhere.",
    pathParams: n.object({
      datasetId: g.openapi({
        description: "uniquely specifies the dataset wanted"
      })
    }),
    responses: {
      200: Pe.openapi({
        description: "various configured parameters for a map"
      }),
      400: d.openapi({
        description: "bad input parameter"
      }),
      404: d.openapi({
        description: "no such dataset"
      })
    }
  },
  getAbout: {
    method: "GET",
    path: "/dataset/:datasetId/about",
    summary: "obtain the About text for a dataset",
    description: "Obtains information about the datset, in markdown format so it can be easily rendered on a front-end application.",
    pathParams: n.object({
      datasetId: g.openapi({
        description: "uniquely specifies the dataset wanted"
      })
    }),
    responses: {
      200: n.string().openapi({
        description: "About text in markdown format"
      }),
      400: d.openapi({
        description: "bad input parameter"
      }),
      404: d.openapi({
        description: "no such dataset"
      })
    }
  },
  getVersion: {
    method: "GET",
    path: "/version",
    summary: "obtains Mykomap server version information",
    description: "Obtains version information about the backend Mykomap server, in the form of a JSON object",
    responses: {
      200: Oe.openapi({
        description: "information about the current Mykomap server build"
      })
    }
  }
}), H = (e) => e.reduce((t, i) => vt(t, i), void 0), Q = (e) => e.reduce((t, i) => gt(t, i), void 0), Nt = (e) => typeof e == "boolean";
function bt(e) {
  switch (e.trim().toLowerCase()) {
    case "true":
    case "t":
    case "yes":
    case "y":
    case "1":
      return !0;
    case "false":
    case "f":
    case "no":
    case "n":
    case "0":
      return !1;
    default:
      return;
  }
}
function St(e, t = !1) {
  if (e == null) return t;
  switch (typeof e) {
    case "string":
      return bt(e) ?? t;
    case "bigint":
    case "number":
      return e == 0;
    case "boolean":
      return e;
    case "object":
      return t;
    case "symbol":
    case "undefined":
    case "function":
    default:
      return t;
  }
}
const Tt = (e) => typeof e == "string", ke = (e, t = "") => typeof e == "string" ? e : t, J = (e, t = 0) => isNaN(e) ? t : e, Zt = (e) => typeof e == "number", Et = (e) => typeof e == "number" && !isNaN(e);
function x(e, t = 0) {
  switch (typeof e) {
    case "number":
      return J(e, t);
    case "string":
      return J(Number.parseFloat(e), t);
    default:
      return t;
  }
}
function N(e) {
  return !(!(e instanceof Array) || e.length < 2 || e.length !== 2 || typeof e[0] != "number" || isNaN(e[0]) || typeof e[1] != "number" || isNaN(e[1]));
}
function Y(e, t) {
  if (e instanceof Array) {
    if (e.length == 2 && typeof e[0] == "number" && typeof e[1] == "number")
      return e;
    if (e.length < 2) return t;
    const i = x(e[0], null), a = x(e[1], null);
    return typeof i == "number" && typeof a == "number" ? [i, a] : t;
  }
  if (e instanceof Object) {
    if ("0" in e && "1" in e) {
      const i = x(e[0], null), a = x(e[1], null);
      if (typeof i == "number" && typeof a == "number") return [i, a];
    }
    return t;
  }
  return t;
}
function Lt(e) {
  return !(!(e instanceof Array) || e.length < 2 || e.length !== 2 || !N(e[0]) || !N(e[1]));
}
function Ut(e) {
  return Number.isFinite(e[0][0]) && Number.isFinite(e[0][1]) && Number.isFinite(e[1][0]) && Number.isFinite(e[1][1]);
}
function Mt(e, t) {
  if (e instanceof Array && e.length >= 2) {
    if (N(e[0]) && N(e[1]))
      return e.length === 2 ? e : [e[0], e[1]];
    const i = Y(e[0], null), a = Y(e[0], null);
    if (i && a) return [i, a];
  }
  return t;
}
function Bt(e, t) {
  return e ? t ? [
    [
      Math.min(e[0][0], e[1][0], t[0][0], t[1][0]),
      Math.min(e[0][1], e[1][1], t[0][1], t[1][1])
    ],
    [
      Math.max(e[0][0], e[1][0], t[0][0], t[1][0]),
      Math.max(e[0][1], e[1][1], t[0][1], t[1][1])
    ]
  ] : e : t || void 0;
}
function gt(e, t) {
  return e == null ? t ?? void 0 : t == null || e < t ? e : t;
}
function vt(e, t) {
  return e == null ? t ?? void 0 : t == null || e > t ? e : t;
}
function $t(e, t) {
  let i = Q(e);
  if (i === void 0) return;
  let a = Q(t);
  if (a === void 0) return;
  let r = H(e);
  if (r === void 0) return;
  let s = H(t);
  if (s !== void 0)
    return [
      [i, a],
      [r, s]
    ];
}
function Ct(e) {
  return e instanceof Array ? e : e == null ? [] : [e];
}
const Vt = (e) => e !== void 0, jt = (e) => e != null;
function Ft(e) {
  return e ? e.filter(jt) : [];
}
function Gt(e, t) {
  if (!e) throw new Error(t);
}
function Kt(e, t) {
  const i = /* @__PURE__ */ new Set();
  return e.forEach((a) => {
    t(a) && i.add(a);
  }), i;
}
function Wt(e, t) {
  let i = "";
  const a = [];
  let r = !1;
  for (var s of e) {
    if (r) {
      i += s, r = !1;
      continue;
    }
    switch (s) {
      case t.delim:
        a.push(i), i = "";
        break;
      case t.escape:
        r = !0;
        break;
      default:
        i += s;
    }
  }
  return a.push(i), a;
}
function It(e) {
  return e.name.replace(/[\/\\\s]+/g, "") + "@" + e.version.join(".");
}
function wt(e) {
  return e.commitDesc.split("-").slice(2).join("-");
}
function Ht(e) {
  Object.keys(e).forEach((t) => delete e[t]);
}
class Qt {
  /** Normalises a text string into an indexable form.
   *
   * Performs these steps:
   * - Lower-cases it
   * - Eliminates non word-breaking punctuation (`\`'`)
   * - Converts all other punctuation to space characters.
   * - Deduplicates whitespace
   * - Trims whitespace from front and back of the string.
   */
  static normalise(t) {
    return t.toLowerCase().replace(/['`]/, "").replace(/[^\w ]+/g, " ").replace(/\s+/g, " ").trim();
  }
}
class Jt {
  _vocabs;
  /** Constructor.
   *
   * @param vocabs - all the vocab definitions we will require to create VocabPropDefs.
   * @param checkLangs - if given, check that the vocabs include translations for these languages.
   */
  constructor(t, i) {
    if (this._vocabs = yt.VocabIndex.parse(t), i) {
      const a = [];
      for (const r in this._vocabs) {
        const s = this._vocabs[r];
        i.every((c) => c in s) || a.push(r);
      }
      if (a.length)
        throw new Error(
          `PropDefServices initialised with these Vocabs which are incompatible with the target languages '${i}': ${a}`
        );
    }
  }
  /** Looks up an interationalised vocab given its URI */
  i18nVocabDef(t) {
    const i = t.replace(/:$/, ""), a = this._vocabs[i];
    if (a == null) throw new Error(`unknown vocab URI: '${t}'`);
    return a;
  }
  mkPropDef(t) {
    switch (t.type) {
      case "value":
        return new Pt(t);
      case "vocab":
        return new xe(t, this.i18nVocabDef(t.uri));
      case "multi":
        const i = this.mkPropDef(t.of);
        return new Ot({ ...t, of: i });
    }
  }
  /** Make a Record of indexed PropDefs from a Dictionary of ProfSpecs
   *
   *
   * @param specs - a Dictionary of PropSpecs.
   * @returns A record of PropDefs, indexed by the same keys as the
   * relevant PropSpec.
   *
   * A Dictionary may have undefined elements; a Record, by definition, doesn't.
   * This function should honour that, and guarantee none.
   */
  mkPropDefs(t) {
    const i = {};
    for (const a in t) {
      const r = t[a];
      r != null && (i[a] = this.mkPropDef(r));
    }
    return i;
  }
}
class C {
  from;
  titleUri;
  filter;
  search;
  /** Constructor.
   *
   * @param init - the specification to use
   */
  constructor(t) {
    this.from = t.from, this.titleUri = t.titleUri, this.filter = t.filter ?? !1, this.search = !!t.search;
  }
  /** @return true if and only if a filter should be created for this PropDef */
  isFiltered() {
    return !!this.filter;
  }
}
class Pt extends C {
  /** The type specifier */
  type = "value";
  /** Conversion hints */
  as;
  nullable;
  strict;
  /** Constructor
   * @param init - the specification for the ValuePropDef
   */
  constructor(t) {
    super(t), this.as = t.as, this.nullable = t.nullable === !0, this.strict = t.strict === !0;
  }
  /**
   * This is always undefined for instances of this class, as they don't have URIs.
   */
  get uri() {
  }
  textForValue(t) {
    return t === void 0 ? void 0 : ke(t);
  }
}
class xe extends C {
  /** Constructor
   * @param init - the specification for the VocabPropDef
   * @param i18nVocab - the internationalised vocab definitions to use
   */
  constructor(t, i) {
    super(t), this.i18nVocab = i, this.uri = t.uri;
  }
  /** The type specifier */
  type = "vocab";
  /** The (abbreviated) vocabulary URI */
  uri;
  /** Looks up a localised vocab, given a language code */
  localisedVocabDef(t) {
    const i = this.i18nVocab[t];
    if (i == null)
      throw new Error(
        `no terms defined for language code '${t}' in vocab '${this.uri}'`
      );
    return i;
  }
  textForValue(t, i) {
    if (i === void 0)
      throw new Error(`no language code provided for vocab '${this.uri}'`);
    return typeof t == "string" ? this.localisedVocabDef(i).terms[t] : "";
  }
}
class Ot extends C {
  type = "multi";
  of;
  /**
   * This indicates the vocab URI in use if pertinent. It is undefined otherwise
   */
  get uri() {
    if (this.of.type === "vocab") return this.of.uri;
  }
  /**
   * This indicates the internationalised vocab definition in use if it contains vocab values. It
   * is undefined otherwise.
   */
  i18nVocab;
  /** Constructor
   *
   * @param init - the specification for this MultiPropSpec. Note, we insist on
   * the of: parameter to be concrete so we can delegate getTextForProperty
   * calls to it.
   */
  constructor(t) {
    super(t), this.of = t.of, t.of instanceof xe && (this.i18nVocab = t.of.i18nVocab);
  }
  textForValue(t, i) {
    return t instanceof Array ? t.map((a) => ke(this.of.textForValue(a, i))) : [];
  }
}
class Yt {
  /** A stub method for executing commands.
   *
   * Typically this will be a reference to `spawnSync`, provided by NodeJS. But
   * since we want this class to be defined without NodeJS dependencies, so it
   * can be included everywhere and only used in vite.config.ts, it needs to be
   * provided via the constructor.
   */
  exec;
  /** The name of the software component */
  name;
  /* The time it was built. Should be a UTC ISO string as returned by Date.toISOString() */
  buildTime;
  /** The commit descriptor. Should be a string as returned by gitDescribe() */
  commitDesc;
  /** The tagged version. Should be a numeric array as returned by
   * gitVersion() */
  version;
  /** The build environment. A string, typically 'development' or 'production',
   * but may be an empty string if nothing is set */
  nodeEnv;
  /** Convenience method to get a sentryRelease string for this instance */
  get sentryRelease() {
    return It(this);
  }
  /** Convenience method to get a sentryDist string for this instance */
  get sentryDist() {
    return wt(this);
  }
  /** Obtain a numeric version array from git tags.
   *
   * Calls `git-describe` to search backwards in the git history for the last
   * "versiony" tag. Meaning, a match for any tag beginning with a `v`, followed
   * by one or more unsigned decimal numbers delimited by single periods.
   *
   * It then attempts to parse that by splitting on non-numeric characters and
   * converting to a list of positive integers.
   *
   * Assumes the code is running in a git working directory!
   *
   * If we can't find any matching tags, we return an array with a single zero:
   * `[0]`
   *
   */
  gitVersion() {
    const t = this.exec("git", [
      "describe",
      "--tags",
      "--match=v[0-9]*",
      "--exclude=v*[^0-9.]*",
      "--exclude=*..*",
      "--exclude=*.",
      "--abbrev=0"
    ]).trim();
    return typeof t == "string" ? t.substring(1).split(".").map(Number) : [0];
  }
  /** Get the git-describe commit information.
   *
   * This provides version information for a more discerning audience. It uses
   * `git-describe` to search back through the history for any tag at all.
   *
   * The result will be a string with the format: "[<TAG>-<COUNT>-]<COMMIT-ID>[-dirty]"
   * - Items in square brackets may be absent.
   * - TAG is the last "versiony" tag found in the commit history, if there is one,
   *   otherwise this and the next dash delimiter are omitted.
   * - COUNT is the number of commts from the tag (or the first commit if none) to the current commit.
   * - COMMIT-ID is the abbreviated SHA1 commit ID.
   * - A "dirty" suffix indicates a build in a dirty working directory.
   * - Note that TAG may contain any character a tag can, including a hyphen.
   * - Therefore it might not be a version string.
   *
   * (See the docs for `gitVersion` for the meaning of "versiony".)
   */
  gitDescribe() {
    return this.exec("git", [
      "describe",
      "--tags",
      "--match=v[0-9]*",
      "--exclude=v*[^0-9.]*",
      "--always",
      "--long",
      "--dirty"
    ]).trim();
  }
  updatePackageJson() {
    const { version: t, sentryRelease: i } = this;
    this.exec("npm", [
      "pkg",
      "set",
      "version=" + t.join("."),
      "config.sentry.release=" + i
    ]);
  }
  /** Constuctor.
   *
   * The `name` parameter is required, all others have defaults inferred from `git-describe`
   */
  constructor(t) {
    this.exec = t.exec, this.name = t.name, this.buildTime = t?.buildTime ?? (/* @__PURE__ */ new Date()).toISOString(), this.commitDesc = t?.commitDesc ?? this.gitDescribe(), this.version = t?.version ?? this.gitVersion(), this.nodeEnv = t?.nodeEnv ?? process.env.NODE_ENV ?? "", Object.defineProperty(this, "exec", { enumerable: !1 });
  }
}
export {
  ee as AbbrevUri,
  C as CommonPropDef,
  ae as DatasetItemId,
  at as DatasetItemIdOrIx,
  re as DatasetItemIx,
  st as Iso639Set1Codes,
  Ot as MultiPropDef,
  O as NCName,
  ie as PrefixUri,
  Jt as PropDefsFactory,
  R as QName,
  Yt as ReadonlyBuildInfo,
  h as RxUtils,
  Qt as TextSearch,
  rt as UAON,
  Re as UrlSafeBase64,
  Pt as ValuePropDef,
  xe as VocabPropDef,
  H as arrayMax,
  Q as arrayMin,
  $t as arrays2Box2d,
  Gt as assert,
  St as boolify,
  Bt as box2dUnion,
  Ht as clear,
  Ft as compactArray,
  qt as contract,
  Kt as filterSet,
  vt as highest,
  Nt as isBool,
  Lt as isBox2d,
  Ut as isFiniteBox2d,
  Zt as isNumber,
  N as isPoint2d,
  Tt as isString,
  gt as lowest,
  jt as notNullish,
  Vt as notUndefined,
  x as numberify,
  Dt as parseAbbrevUri,
  Ct as promoteToArray,
  yt as schemas,
  wt as sentryDist,
  It as sentryRelease,
  _t as specification,
  Wt as splitField,
  ke as stringify,
  bt as textToBool,
  Mt as toBox2d,
  Y as toPoint2d,
  J as toYesANumber,
  Et as yesANumber
};
